import { render, staticRenderFns } from "./ChangePhoneForm.vue?vue&type=template&id=35c31199&scoped=true"
import script from "./ChangePhoneForm.vue?vue&type=script&lang=js"
export * from "./ChangePhoneForm.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoneForm.vue?vue&type=style&index=0&id=35c31199&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c31199",
  null
  
)

export default component.exports